export { default } from './WeightedAverageScale';
export {
	default as WeightedAverageInfoText,
	type InfoText,
} from './WeightedAverageInfoText';
